import { render, staticRenderFns } from "./AlignxcelReleaseVersionMaster.vue?vue&type=template&id=ad9873ce&scoped=true&"
import script from "./AlignxcelReleaseVersionMaster.vue?vue&type=script&lang=js&"
export * from "./AlignxcelReleaseVersionMaster.vue?vue&type=script&lang=js&"
import style0 from "./AlignxcelReleaseVersionMaster.vue?vue&type=style&index=0&id=ad9873ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9873ce",
  null
  
)

export default component.exports